import React, { forwardRef } from "react";
import styled, { css, CSSProperties } from "styled-components";

interface DocumentTextFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: React.ReactNode;
  errorMessage?: string;
  inputStyle?: CSSProperties | undefined;
}

const DocumentTextField = forwardRef<HTMLInputElement, DocumentTextFieldProps>(
  ({ leftIcon, className, style, errorMessage, inputStyle, ...rest }, ref) => {
    return (
      <WrapStyle>
        <TextFieldStyle
          className={className}
          style={style}
          error={!!errorMessage}
        >
          {leftIcon}
          <input style={inputStyle} {...rest} ref={ref} />
        </TextFieldStyle>
        {errorMessage && <label>{errorMessage}</label>}
      </WrapStyle>
    );
  },
);
DocumentTextField.displayName = "DocumentTextField";

export default DocumentTextField;

/* 스타일 */
const WrapStyle = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.6rem;

  label {
    padding-left: 1.6rem;
    ${({ theme }) => theme.typography.body3.regular};
    color: ${({ theme }) => theme.color.text.danger};
  }
`;

const TextFieldStyle = styled.div<{ error: boolean }>`
  display: inline-flex;
  padding: 1.6rem;
  align-items: center;
  gap: 0.8rem;
  overflow: hidden;
  width: 100%;
  height: 5.6rem;
  box-sizing: border-box;

  border-radius: 0.5rem;
  background: ${({ theme }) => theme.color.background.dark};
  ${({ theme, error }) =>
    error &&
    css`
      border: 0.1rem solid ${theme.color.text.danger};
    `}

  input {
    flex: 1;
    width: 100%;

    background: none;
    border: none;
    outline: none;
    padding: 0;

    ${({ theme }) => theme.typography.body1.regular}
    letter-spacing: -0.048rem;

    ::placeholder {
      color: ${({ theme }) => theme.color.text.placeholder};
    }
  }

  svg {
    width: 2.4rem;
    height: 2.4rem;
    flex-shrink: 0;
    color: ${({ theme }) => theme.color.icon.tertiary};
  }

  &:hover {
    background: #eceef4;
  }

  ${({ theme }) => theme.media.small} {
    height: 4.4rem;
    padding: 1.3rem 1.6rem;

    input {
      ${({ theme }) => theme.typography.body3.regular}
    }
  }
`;
